import React from 'react';
import OtpVerificationForm from './OtpVerficationForm';
import { Modal} from "react-bootstrap";

interface IOtpVerificationModal {
    displayOtpModal: boolean;
    setDisplayOtpModal: (boolean) => void;
    handleOtpVerification: (values, setSubmitting) => void;
    resendOtp: (setSubmitting) => void;
    userEmail: string;
    otpExpiryTime
}

const OtpVerificationModal: React.FC<IOtpVerificationModal> = ({
    displayOtpModal,
    setDisplayOtpModal,
    handleOtpVerification,
    resendOtp,
    userEmail,
    otpExpiryTime
}) => {

    return (
        <Modal
            show={displayOtpModal}
            onHide={() => setDisplayOtpModal(false)}
            centered
            className="theme-modal-style app_container_wrap nor-padding border-radius-15"
        >
            <Modal.Header className="x-4">
                <button
                    type="button"
                    className="btn modal-close-button pe-0"
                    onClick={() => setDisplayOtpModal(false)}
                >
                    Close
                </button>
            </Modal.Header>
            <Modal.Body className="app_container_wrap px-1 py-2 text-center">
                <OtpVerificationForm
                    handleOtpVerification={handleOtpVerification}
                    resendOtp={resendOtp}
                    userEmail={userEmail}
                    otpExpiry={otpExpiryTime}
                />
            </Modal.Body>
        </Modal>
    );
};

export default OtpVerificationModal;
